import { render } from "./Footer.vue?vue&type=template&id=3d302860&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3d302860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d302860"],['__file',"src/components/layout/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d302860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d302860', __exports__)) {
    api.reload('3d302860', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=3d302860&scoped=true", () => {
    api.rerender('3d302860', render)
  })

}


export default __exports__